// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/affix/style/index.less
// module id = 1051
// module chunks = 1